export const Quote = () => {
  return (
    <svg viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 8.39891C1 6.1491 1.37961 3.91541 2.12283 1.79191L2.4 1H5.2L4.5 5.5H8V13H1V8.39891Z"
        stroke="currentColor"
        strokeLinejoin="round"
      />
      <path
        d="M10 8.39891C10 6.1491 10.3796 3.91541 11.1228 1.79191L11.4 1H14.2L13.5 5.5H17V13H10V8.39891Z"
        stroke="currentColor"
        strokeLinejoin="round"
      />
    </svg>
  )
}
